import { useMutation } from "@apollo/client/react";
import { DELETE_MONITOR_EXCLUSION } from "../../mutations/aml/deleteMonitorExclusion";
import GET_ALL_MONITOR_EVENTS from "../../queries/aml/getAllMonitorEvents";
import GET_CLIENT_MONITORING_EVENTS from "../../queries/aml/getClientMointoringEvents";

export const useDeleteMonitorExclusion = ({
  onCompleted,
  onError,
  skipRefetch,
}: any) => {
  const [deleteMonitorExclusion, { data, loading, error }] = useMutation(
    DELETE_MONITOR_EXCLUSION,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: skipRefetch
        ? []
        : [GET_CLIENT_MONITORING_EVENTS, GET_ALL_MONITOR_EVENTS],
      awaitRefetchQueries: true,
    }
  );

  return { deleteMonitorExclusion, data, loading, error };
};
